import { computed, Directive, effect, input, signal } from '@angular/core';

@Directive({
  selector: 'img[altImg]',
  standalone: false,
  'host': {
    '(error)' : 'nextAlt()',
    '[src]': 'selected()'
  }
})
export class AltImg {
  readonly altImg=input.required<string[]>();
  readonly ind=signal<number>(0);
  private oldList: string=null;
  
  readonly selected=computed(() => {
    if(this.ind()<this.altImg().length)
      return this.altImg()[this.ind()];
    else
      return 'img/logo/logo-trasnparent.png';
  });

  constructor() {
    // Se déclenche à chaque *vrai* changement de altImg()
    effect(() => {
      let json: string=JSON.stringify(this.altImg());
      if(json!=this.oldList){
        this.oldList=json;
        this.ind.set(0);
      }
    });
  }

  nextAlt(){
    this.ind.update(val => val+=1);
  }
}
